import {
  ListTasksCommandInput,
  CreateTaskCommandInput,
  AuditorUpdateTaskCommandInput,
} from '@amzn/gbsa-helios-typescript-client';

export const taskKeys = {
  all: ['task'] as const,
  list: ({
    businessUnitId,
    questionId,
    auditId,
  }: Pick<ListTasksCommandInput, 'businessUnitId' | 'questionId' | 'auditId'>) =>
    [...taskKeys.all, 'list', businessUnitId, questionId, auditId] as const,
  create: ({ businessUnitId }: Pick<CreateTaskCommandInput, 'businessUnitId'>) =>
    [...taskKeys.all, 'create', businessUnitId] as const,
  auditorUpdate: ({
    businessUnitId,
    taskId,
  }: Pick<AuditorUpdateTaskCommandInput, 'businessUnitId' | 'taskId'>) =>
    [...taskKeys.all, 'auditorUpdate', businessUnitId, taskId] as const,
};
